module.exports = __webpack_public_path__ + "static/img/8_male.b02cdc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/character/8_male.png
// module id = LIqf
// module chunks = 0